import { render, staticRenderFns } from "./UiSelect.vue?vue&type=template&id=0e241528&scoped=true&"
import script from "./UiSelect.vue?vue&type=script&lang=js&"
export * from "./UiSelect.vue?vue&type=script&lang=js&"
import style0 from "./UiSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UiSelect.vue?vue&type=style&index=1&id=0e241528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e241528",
  null
  
)

export default component.exports